var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.value,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(ref){
var item = ref.item;
return [_c('td',[_vm._v(_vm._s(_vm.$t(item.dow)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.start)+"–"+_vm._s(item.end))])]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e9b9486","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/intent/IntentScheduleTable.vue
// module id = null
// module chunks = 